import {Tooltip} from 'platform/components';
import {Link} from 'platform/foundation';

import {useGetTenantQuery} from '@dms/api/core';
import {useGetAuthorizationProfileQuery} from '@dms/api/security';
import i18n from '@dms/i18n';

import {TestIdProps} from 'shared/web';

export interface AuthorizationProfileProps extends TestIdProps {
  recordId: string;
  isEditable?: boolean;
  onChange?: () => void;
}

export function AuthorizationProfile(props: AuthorizationProfileProps) {
  const {data: tenant} = useGetTenantQuery();

  const {data: authorizationProfile} = useGetAuthorizationProfileQuery(
    {
      authorizationProfileId: props.recordId,
      'x-tenant': tenant?.id ?? '',
    },
    {skip: !props.recordId || !tenant?.id}
  );

  if (!authorizationProfile?.name) {
    return null;
  }

  const isDisabled = !props.isEditable || !props.onChange;

  return (
    <Tooltip
      label={i18n.t('entity.header.labels.authorizationProfile')}
      childrenWrapperDisplay="flex"
    >
      <Link
        size="small"
        isDisabled={isDisabled}
        leftIcon="sidebar/my_profile_security"
        title={authorizationProfile.name}
        onClick={props.onChange}
        data-testid={props['data-testid']}
      />
    </Tooltip>
  );
}
